import { FaTags } from 'react-icons/fa';
import { getDiscountCodeByCode } from '../../hooks';
import { currencyFormat } from 'legacy/common/utils/currency';

function DiscountCode({ eventId, code }) {
  const { data: discountCode, isLoading } = getDiscountCodeByCode(
    eventId,
    code
  );

  return !isLoading && discountCode ? (
    <div className="mt-2 w-full rounded-lg bg-primary-200 flex items-center p-4">
      <div className="text-xl">
        <FaTags />
      </div>
      <div className="flex flex-col ml-4">
        {discountCode?.discount ? (
          <>
            <div className="flex flex-row">
              <div className="font-bold mr-1">{discountCode.code}</div> applied!
            </div>
            <div className="text-gray-400">
              -
              {discountCode.discount.kind === 'amount' &&
                `${currencyFormat(discountCode.discount.value)}`}
              {discountCode.discount.kind === 'percentage' &&
                `${discountCode.discount.value}%`}
              &nbsp;off
            </div>
          </>
        ) : (
          <div className="flex flex-row">
            <div className="font-bold mr-1">{discountCode.code}</div> applied!
            Time to lock in your spot!
          </div>
        )}
      </div>
    </div>
  ) : null;
}

export default DiscountCode;
